import React, { useState, useEffect } from 'react';
import { db, storage } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { ref, listAll, getDownloadURL } from 'firebase/storage';
import { Box, Modal, Typography, IconButton, Grid, Avatar, useMediaQuery } from '@mui/material';
import MoodIcon from '@mui/icons-material/Mood';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';

const StickerGallery = ({ username, avatarUrl, role }) => {
  const [open, setOpen] = useState(false);
  const [stickers, setStickers] = useState([]);
  const theme = useTheme();

  // Detecta el tamaño de la pantalla
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  useEffect(() => {
    const fetchStickers = async () => {
      const stickersRef = ref(storage, 'stickers/'); // Carpeta de stickers en Firebase Storage
      try {
        const stickerList = await listAll(stickersRef);
        const urls = await Promise.all(stickerList.items.map(item => getDownloadURL(item)));
        setStickers(urls);
      } catch (error) {
        console.error('Error al cargar los stickers:', error);
      }
    };
    fetchStickers();
  }, []);

  const handleSendSticker = async (stickerUrl) => {
    try {
      await addDoc(collection(db, 'messages'), {
        stickerUrl,
        username,
        avatarUrl,
        timestamp: serverTimestamp(),
        role,
      });
      setOpen(false);
    } catch (error) {
      console.error('Error al enviar sticker:', error);
    }
  };

  return (
    <>
      <IconButton color="primary" onClick={() => setOpen(true)}>
        <MoodIcon />
      </IconButton>

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: isMobile ? '90%' : 400, // Responsive en móviles
          maxWidth: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6">Selecciona un Sticker</Typography>
            <IconButton onClick={() => setOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Grid 
            container 
            spacing={2} 
            justifyContent="center"
            columns={isMobile ? 4 : isTablet ? 6 : 8} // Responsive columnas
          >
            {stickers.map((sticker, index) => (
              <Grid item xs={1} key={index}>
                <Avatar
                  src={sticker}
                  sx={{
                    width: isMobile ? 40 : 60, // Tamaño adaptable
                    height: isMobile ? 40 : 60,
                    cursor: 'pointer',
                    border: '2px solid #ddd',
                    '&:hover': { border: '2px solid #3f51b5' }
                  }}
                  onClick={() => handleSendSticker(sticker)}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Modal>
    </>
  );
};

export default StickerGallery;
